import { render, staticRenderFns } from "./SkupTemaCreate.vue?vue&type=template&id=56d1a769&scoped=true&"
import script from "./SkupTemaCreate.vue?vue&type=script&lang=js&"
export * from "./SkupTemaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1a769",
  null
  
)

export default component.exports